module.exports = __webpack_public_path__ + "img/imgprd.81b6c4c4.jpg";